export { EditorView } from "./editorview";
export { ViewPlugin, PluginFieldProvider, PluginField, ViewUpdate, logException } from "./extension";
export { Decoration, WidgetType, BlockType } from "./decoration";
export { BlockInfo } from "./heightmap";
export { themeClass } from "./theme";
export { BidiSpan, Direction } from "./bidi";
export { keymap, runScopeHandlers } from "./keymap";
export { drawSelection } from "./draw-selection";
export { highlightSpecialChars } from "./special-chars";
export { highlightActiveLine } from "./active-line";
export { placeholder } from "./placeholder";
export { Range } from "@codemirror/next/rangeset";
import { HeightMap, HeightOracle, MeasuredHeights, QueryType } from "./heightmap";
import { ChangedRange } from "./extension";
import { computeOrder, moveVisually } from "./bidi";
/// @internal
export const __test = { HeightMap, HeightOracle, MeasuredHeights, QueryType, ChangedRange, computeOrder, moveVisually };
